package fr.labodoc.healthProfessional.webApp.pages.profile.profileInformation

import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow

abstract class ProfileInformationViewModel {
  sealed class UiState {
    data object Loading : UiState()

    data class Loaded(
      val firstName: String,
      val lastName: String,
      val rppsNumber: String?,
      val medicalProfession: String?,
      val professionalCategory: String,
      val medicalSpeciality: String?,
      val department: String,
      val email: String
    ) : UiState()

    data object Error : UiState()
  }

  sealed class Event {
    data class ChangePasswordFailed(
      val errorCode: String
    ) : Event()

    object ChangePasswordSucceed : Event()

    data class DeleteAccountFailed(
      val errorCode: String
    ) : Event()

    object DeleteAccountSucceed : Event()
  }

  abstract val uiState: StateFlow<UiState>

  abstract val events: SharedFlow<Event>

  abstract fun changePassword(oldPassword: String, newPassword: String)

  abstract fun deleteAccount()
}
